import Control from "./Control.js"
import Utils from "./Utils.js"

export default class Slider extends Control {

  constructor(props, context) {
    super(props, context)
    this.state.percent = 0
    this.state.value = 0
    this.state.min = 0
    this.state.range = 0
    this.state.max = 1
    this.state.dragging = false
    this.increment = 0.1
    this.classList.add("amp-slider")
    this.direction = ""

    this.bindHandlers(["onHandleMouseDown", "onHandleMouseUp", "onHandleMouseMove"])
  }

  static get contextTypes() {
    return super.contextTypes
  }

  format(value) {
    return value
  }

  update(values) {
    if (values.percent == null && values.value != null)
      values.percent = values.value / this.max

    if (values.value == null && values.percent != null)
      values.value = Math.round(values.percent * this.max)

    if (values.valueText == null && values.value != null)
      values.valueText = `${this.format(values.value)} ${this.getLocalizedString("MSG_OF")} ${this.format(this.max)}`

    // Handles NaN cases that cause unpredictable seek results
    if (!Utils.isNumber(values.value))
      delete values.value

    if (!Utils.isNumber(values.percent))
      delete values.percent

    this.setState(values)
    return values
  }

  set percent(value) {
    value = akamai.amp.Utils.clamp(value, 0, 1)

    if (this.percent == value)
      return

    this.change(this.update({percent: value}))
  }

  get percent() {
    return this.state.percent
  }

  set value(value) {
    value = akamai.amp.Utils.clamp(value, this.min, this.max)

    if (this.value == value)
      return

    this.change(this.update({value}))
  }

  get value() {
    return this.state.value
  }

  set range(value) {
    value = akamai.amp.Utils.clamp(value, this.min, this.max)

    if (this.range == value)
      return

    this.setState({range: value})
  }

  get range() {
    return this.state.range
  }

  set min(value) {
    if (this.min == value)
      return

    this.setState({min: value})
  }

  get min() {
    return this.state.min
  }

  set max(value) {
    if (this.max == value)
      return

    this.setState({max: value})
  }

  get max() {
    return this.state.max
  }

  set dragging(value) {
    if (this.dragging == value)
      return

    this.setState({dragging: value})
    this.classList.update({"amp-dragging": value})
    this.plugin.dragging = value
  }

  get dragging() {
    return this.state.dragging
  }

  get markers() {
    return this.refs.markers
  }

  get aria() {
    return Object.assign(super.aria, {
      role: "slider",
      "aria-valuemin": this.state.min,
      "aria-valuemax": Math.round(this.state.max),
      "aria-valuenow": Math.round(this.state.value),
      "aria-valuetext": this.state.valueText
    })
  }

  move(event) {
    const offset = this.refs.element.getBoundingClientRect()
    const pos = Utils.getEventPos(event)
    if(this.direction === "vertical") {
    	this.percent = 1-(pos.y - offset.top) / offset.height
    }
    else {
    	this.percent = (pos.x - offset.left) / offset.width
    }
   	
  }

  onClick(event) {
  	if(this.player.playState != "ready")
    	this.move(event)
  }

  onAction() {

  }

  onKeyPress(event) {
    const code = event.keyCode
    // left arrow 37
    // up arrow 38
    // right arrow 39
    // down arrow 40
    if (code == 39 || code == 38) {
      this.percent += this.increment
    } else if (code == 37 || code == 40) {
      this.percent -= this.increment
    }
  }

  onHandleMouseDown(event) {
    if (this.player.playState == "ready")
      return

    event.stopPropagation()
    event.preventDefault()
    this.dragging = true
    window.addEventListener("mouseup", this.onHandleMouseUp)
    window.addEventListener("mousemove", this.onHandleMouseMove)
    window.addEventListener("touchend", this.onHandleMouseUp)
    window.addEventListener("touchmove", this.onHandleMouseMove)
  }

  onHandleMouseMove(event) {
    this.move(event)
  }

  onHandleMouseUp(event) {
    event.stopPropagation()
    event.preventDefault()
    this.dragging = false
    window.removeEventListener("mouseup", this.onHandleMouseUp)
    window.removeEventListener("mousemove", this.onHandleMouseMove)
    window.removeEventListener("touchend", this.onHandleMouseUp)
    window.removeEventListener("touchmove", this.onHandleMouseMove)
    this.change(this.update({value: this.value, percent: this.percent}))
  }

  render() {
    const percent = `${Utils.round(this.percent * 100, 2)}%`
    const range = `${Utils.round(this.range * 100, 2)}%`
    return (
      <div ref="element" {...this.propsList} onMouseMove={this.onMouseMove}>
        <div ref="track" className="amp-track"></div>
        <div ref="range" className="amp-range" style={{width: range}}></div>
        <div ref="value" className="amp-value" style={{width: percent}}></div>
        {this.children}
        <div ref="handle" className="amp-handle" style={{left: percent}} onMouseDown={this.onHandleMouseDown} onTouchStart={this.onHandleMouseDown}></div>
      </div>
    )
  }

}
